// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MVNa","toggleWrap":"styles_toggleWrap__3qMR1","content":"styles_content__oz24f","selectAreaCode":"styles_selectAreaCode__3VkDD"};